// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2J1XG","footer":"ModalInfo_footer__2WDac"};